import React, {useRef,  useEffect,  useState,  forwardRef,  useImperativeHandle, } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Button, DialogActions, IconButton, } from '@mui/material';
import closeButton from '../../Assets/popup-close.svg';
import Checkbox from '@mui/material/Checkbox';
import MultiSelectDropdown from './MultiSelectDropdown';
import { styled } from '@mui/material/styles';
import { use } from 'react';

import WorkflowTemplateServiceController from '../../Controllers/WorkflowTemplateservice';



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});
const workflowTempcont = new WorkflowTemplateServiceController();
const FilterPreview =forwardRef((props, ref)  => {
  let { openPre, closePre ,filterDropdownValues,handleApplyFilters,isEdit,addFilters,workflowTemplateId,...rest } = props;

  const [selectFilterOptions,setSelectFilterOptions] = useState(
    {
      HiringManager : [],
      Recruiter : [],
      JobTitle : [],
      WorkEngagementType : [],
      Location : [],
      YearOfExperience: []
    }
    );
    const [test, setTest]=useState(false);
    const [selectFilterOptionsDetails,setSelectFilterOptionsDetails] = useState(
      {
        HiringManager : [],
        Recruiter : [],
        JobTitle : [],
        WorkEngagementType : [],
        Location : [],
        YearOfExperience: []
      }
      );
    const [filterOptionSelected,setFilterOptionSelected] = useState(
      {
        HiringManager : [],
        Recruiter : [],
        JobTitle :  [],
        WorkEngagementType : [],
        Location : [],
        YearOfExperience: [],

      }
    );
    
    // CHANGE: Store the initial filter state from API
    const [initialFilterState, setInitialFilterState] = useState(null);
    
    const [filterOptionSelectedForJson,setFilterOptionSelectedForJson]=useState(
       addFilters.length > 0 ?addFilters :
      [
        {
            "criteria": [],
            "id": 1,
            "fieldName": "Hiring Manager",
            "fieldCode": "HiringManager",
            "createdDate": "2025-01-30T04:46:28.7611656Z",
            "createdBy": 0,
            "modifiedDate": null,
            "modifiedBy": null,
            "isActive": false
        },
        {
            "criteria":[],
            "id": 2,
            "fieldName": "Recuriter",
            "fieldCode": "Recuriter",
            "createdDate": "2025-01-30T04:46:28.7611685Z",
            "createdBy": 0,
            "modifiedDate": null,
            "modifiedBy": null,
            "isActive": false
        },
        {
            "criteria": [],
            "id": 3,
            "fieldName": "Job Title",
            "fieldCode": "JobTitle",
            "createdDate": "2025-01-30T04:46:28.7611691Z",
            "createdBy": 0,
            "modifiedDate": null,
            "modifiedBy": null,
            "isActive": false
        },
        {
            "criteria": [],
            "id": 4,
            "fieldName": "Work Engagement Type",
            "fieldCode": "WorkEngagementType",
            "createdDate": "2025-01-30T04:46:28.7611696Z",
            "createdBy": 0,
            "modifiedDate": null,
            "modifiedBy": null,
            "isActive": false
        },
        {
            "criteria": [],
            "id": 5,
            "fieldName": "Location",
            "fieldCode": "Location",
            "createdDate": "2025-01-30T04:46:28.7611748Z",
            "createdBy": 0,
            "modifiedDate": null,
            "modifiedBy": null,
            "isActive": false
        },
        {
            "criteria": [],
            "id": 6,
            "fieldName": "Year of Experience",
            "fieldCode": "YearOfExperience",
            "createdDate": "2025-01-30T04:46:28.7611764Z",
            "createdBy": 0,
            "modifiedDate": null,
            "modifiedBy": null,
            "isActive": false
        }],
    )


const dummyData  = "Dummy DATA in Filter preview";
    const createFilterDataJson=()=>{
      const filterData = filterOptionSelectedForJson;
      return filterData;
    }
useImperativeHandle(ref, () => ({
createFilterDataJson,dummyData
  }));

const [updatedDropdown,setUpdatedDropdown] = useState([]);

    useEffect(() => {
      
      // CHANGE: Store the initial filter state when the dialog opens
      if (initialFilterState === null) {
        setInitialFilterState({
          filterOptionSelected: JSON.parse(JSON.stringify(filterOptionSelected)),
          filterOptionSelectedForJson: JSON.parse(JSON.stringify(filterOptionSelectedForJson)),
          updatedDropdown: JSON.parse(JSON.stringify(updatedDropdown))
        });
      }
      
      Object.keys(selectFilterOptions).forEach(optionKey => {
        settingFilterDropdownValues(optionKey);
      });
      
        }, [openPre,filterDropdownValues]);
        useEffect(() => {
          if(isEdit){
            const updatedCheckedState = addFilters.map((filter, index) => {
          return filterOptionSelectedForJson.some(
                 (option)=> option.criteria.length > 0 && 
                 option.criteria.some((criterion) => criterion.isActive!== false &&
                 option.fieldCode === filter.fieldCode 
                ));
            });
            
            setCheckedState(updatedCheckedState);
        const updatedDropdownValues = addFilters.flatMap((filter, index) => {
        return filterOptionSelectedForJson.filter(
             (option)=> option.criteria.length > 0 && option.fieldCode === filter.fieldCode 
            );
        });       
      
     setUpdatedDropdown(updatedDropdownValues);
          }
          
      }, [filterOptionSelectedForJson, test]);
        
  const settingFilterDropdownValues = (optionList) => {
    const mapDetails =(fieldCode)=>  filterDropdownValues
      .filter(filter => filter.fieldCode === fieldCode)
      .flatMap(filter => 
        Array.isArray(filter.individualDetails) && filter.individualDetails.length > 0 
          ? filter.individualDetails.map(details => ({
              id: details.id,
              label: details.text,
              value: details.value
            }))
          : []
      );
      const filterDetails = (fieldCode) => 
        filterDropdownValues
          .filter(filter => filter.fieldCode === fieldCode)
          .map(filter => ({
            id: filter.id,
            fieldName: filter.fieldName,
            fieldCode: filter.fieldCode
          }));

      setSelectFilterOptions(prevValues => ({
        ...prevValues,
        [optionList]: mapDetails(optionList)
      }));
      setSelectFilterOptionsDetails(prevValues => ({
        ...prevValues,
        [optionList]: filterDetails(optionList)
      }));

      if (isEdit) {
      
        const updateFilterOptionSelected = (workflowData) => {
          const updatedOptions = { ...filterOptionSelected };
      
          workflowData.forEach((item) => {
            item.criteria.forEach((criterion) => {
              const matchingOptions = mapDetails(item.fieldCode).filter((detail) =>
               criterion.isActive !== false && criterion.workflowFilterFieldValue === detail.value
              );
      
              // Ensure we accumulate all matching options without duplicates
              if (updatedOptions[item.fieldCode]) {
                updatedOptions[item.fieldCode] = [
                  ...updatedOptions[item.fieldCode],
                  ...matchingOptions.filter(
                    (newOption) =>
                      !updatedOptions[item.fieldCode].some(
                        (existingOption) => existingOption.value === newOption.value
                      )
                  ),
                ];
              } else {
                updatedOptions[item.fieldCode] = matchingOptions;
              }
            });
          });
          setFilterOptionSelected(updatedOptions);
        };
      
        updateFilterOptionSelected(updatedDropdown);
      }
  };



  useEffect(()=>{
  },[selectFilterOptionsDetails,filterOptionSelected])

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    closePre();
  };
   const filters=Array(6).fill(null);
  
  const [checkedState, setCheckedState] = useState(
    new Array(filters.length).fill(false)
  );

  useEffect(() => {
  }, [checkedState]);

useEffect(()=>{
},[filterOptionSelectedForJson]);

  const handleChange = (index) => {
    const updatedCheckedState = checkedState.map((item, idx) =>
      idx === index ? !item : item
    );
    setCheckedState(updatedCheckedState);
  };
  useEffect(()=>{
  },[checkedState]);

  const handleFilterChange = (value, index, field) => {    
    // CHANGE 1: Save the current checked state before updating
    const currentCheckedState = [...checkedState];
  
    setFilterOptionSelected((prevValues) => ({
      ...prevValues,
      [field]: value
    }));

    const selectedOption = selectFilterOptionsDetails[field] && selectFilterOptionsDetails[field][0];
    if (!selectedOption) {
      console.error("Selected option not found for field:", field);
      return;
    }
  
    setFilterOptionSelectedForJson((prevValues) => {
    
      const updatedValues = prevValues.map((item) => {
        if (item.fieldCode === field) {
          const newCriteria = value.map((val) => ({
            action: null,
            id: 0,
            workflowFilterFieldId: selectedOption.id,
            workflowTemplateId: workflowTemplateId,
            workflowFilterFieldValue: val.value,
            createdDate: null,
            createdBy: 0,
            modifiedDate: null,
            modifiedBy: null,
            isActive: true,
          }));
    
          // Update existing criteria if already present
          const updatedCriteria = item.criteria.map((existingCriterion) => {
            const matchingNewCriterion = newCriteria.find(
              (newCriterion) =>
                newCriterion.workflowFilterFieldValue === existingCriterion.workflowFilterFieldValue
            );
            if (matchingNewCriterion) {
              return {
                ...existingCriterion,
                id: 0,
                isActive: true,
              };
            }
            return existingCriterion;
          });
    
          // Add new criteria that are not already present
          const uniqueNewCriteria = newCriteria.filter(
            (newCriterion) =>
              !item.criteria.some(
                (existingCriterion) =>
                  existingCriterion.workflowFilterFieldValue === newCriterion.workflowFilterFieldValue
              )
          );
    
          return {
            ...item,
            criteria: [...updatedCriteria, ...uniqueNewCriteria],
            id: selectedOption.id,
            fieldName: selectedOption.fieldName,
            fieldCode: selectedOption.fieldCode,
            createdDate: "2025-01-30T04:46:28.7611656Z",
            createdBy: 0,
            modifiedDate: null,
            modifiedBy: null,
            isActive: true,
          };
        }
        return item;
      });
          
      return updatedValues;
    });
    
    // CHANGE 2: Restore the checked state after updating
    // This ensures the checkbox remains checked after selection
    setTimeout(() => {
    setCheckedState(currentCheckedState);
  }, 0);
  }
  const handleRemoveFields = (valueToRemove, index, field, fieldCode) => {
  
    // Keep track of current checked state
    const currentCheckedState = [...checkedState];
  
    setFilterOptionSelected((prevValues) => {
      if (!prevValues[fieldCode] || !Array.isArray(prevValues[fieldCode])) {
        return prevValues;
      }
      
      // Remove the specific value from the selected options
      const newValues = prevValues[fieldCode].filter(
        (value) => value.value !== valueToRemove.value
      );
      
      // If removing the last item, automatically uncheck the checkbox
      if (newValues.length === 0) {
        const filterIndex = filterDropdownValues.findIndex(
          filter => filter.fieldCode === fieldCode
        );
        if (filterIndex !== -1) {
          const updatedCheckedState = [...currentCheckedState];
          updatedCheckedState[filterIndex] = false;
          setTimeout(() => setCheckedState(updatedCheckedState), 0);
        }
      }
      
      return {
        ...prevValues,
        [fieldCode]: newValues,
      };
    });
  
    // Ensure prevValues[field] is defined and is an array
    setFilterOptionSelectedForJson((prevValues) => {
      // Ensure prevValues is an array and contains the field
      if (!Array.isArray(prevValues)) {
        return prevValues;
      }
  
      const updatedJsonValues = prevValues.map((item) => {
        if (item.fieldCode === fieldCode) {
          return {
            ...item,
            criteria: item.criteria.map((criterion) => 
              criterion.workflowFilterFieldValue === valueToRemove.value
              ? {
                  ...criterion,
                  isActive: false,
                  action: "U",
                }
              : criterion
            ),
          };
        }
        return item;
      });
      
      return updatedJsonValues;
    });
  }


useEffect(()=>{
},[filterOptionSelectedForJson,filterOptionSelected]);

// changing css of MUI button
const ColorButton = styled(Button)(({ theme }) => ({
  color:'#fff',
    backgroundColor:"#02acf6",
  }));

const CancelButton = styled(Button)(({ theme }) => ({
    color:'#fff',
      backgroundColor:"gray",
    }));

// CHANGE: Updated handleCancel function to revert to the initial state
const handleCancel = () => {  
  if (initialFilterState) {
    // Restore the initial filter state from when the dialog was opened
    setFilterOptionSelected(JSON.parse(JSON.stringify(initialFilterState.filterOptionSelected)));
    setFilterOptionSelectedForJson(JSON.parse(JSON.stringify(initialFilterState.filterOptionSelectedForJson)));
    setUpdatedDropdown(JSON.parse(JSON.stringify(initialFilterState.updatedDropdown)));
    
    // Recalculate the checked state based on the restored data
    const restoredCheckedState = filterDropdownValues.map((filter, index) => {
      return initialFilterState.filterOptionSelectedForJson.some(
        (option) => 
          option.criteria.length > 0 && 
          option.criteria.some((criterion) => 
            criterion.isActive !== false && 
            option.fieldCode === filter.fieldCode
          )
      );
    });
    
    setCheckedState(restoredCheckedState);
  } else {
    console.log("No initial state to restore to");
  }  
  closePre();
};
  
  const handleCheckEmptyFilters = () => {
    let empty = false;

    for (let index = 0; index < filterDropdownValues.length; index++) {
      const filter = filterDropdownValues[index];
      const filterOptions = filterOptionSelected[filter.fieldCode];
      const isChecked = checkedState[index];
      const isEmpty =
        Array.isArray(filterOptions) && filterOptions.length === 0;
      if (isChecked && isEmpty) {
        alert(
          "One or more of the filter dropdown(s) is empty. Either fill the dropdown or uncheck the respective filter..."
        );
        empty = true;
        return true; // Stop iterating
      }
    }
    if (!empty) {
      handleApplyFilters();
    }
  };  

  return (
    <Dialog
      open={openPre}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      style={{}}
      aria-describedby="alert-dialog-slide-description"
      slotProps={{
        backdrop: {
          style: { backgroundColor: "rgba(0, 0, 0, 0.1)" }, // Adjust the opacity here
        },
      }}
      maxWidth="md" // Set the maximum width to large
      fullWidth // Make the dialog take up the full width of its container
    >
      <DialogTitle>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0px 5px",
          }}
        >
          <p>Filters</p>
          {/* <IconButton onClick={closePre}>
            <img src={closeButton} alt="close-button" />
          </IconButton> */}
        </div>
      </DialogTitle>
      <DialogContent>

        {filterDropdownValues.map((filter,index) => (
          <div
          key={index}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "2px 10px",
              background: Array.isArray(selectFilterOptions[filter.fieldCode]) && selectFilterOptions[filter.fieldCode].length === 0?"#F6F7FC":"#F3FBFF",
              marginTop: "5px",
              borderRadius: "10px",
              position: "relative",
            }}
          >
               <Checkbox  
               disabled = {Array.isArray(selectFilterOptions[filter.fieldCode]) && selectFilterOptions[filter.fieldCode].length === 0}
                checked={checkedState[index]}
              onChange={() => handleChange(index)} 
              sx={{
                color:'#02acf6',
                "&.Mui-checked": {
                  color: '#02acf6',
                },
              }}
              />
            <p style={{ position: "absolute", left: "10%" }}>{filter.fieldName}</p>
            {
              checkedState[index]  && (
                <MultiSelectDropdown 
                options={selectFilterOptions[filter.fieldCode]} 
                onChange={(value)=>handleFilterChange(value,index,filter.fieldCode)}
                valueSet={filterOptionSelected[filter.fieldCode].length > 0 ? filterOptionSelected[filter.fieldCode] : [] }
                handleRemoveData={(valueToRemove)=>handleRemoveFields(valueToRemove,index, filterOptionSelected[filter.fieldCode],filter.fieldCode)}
                />
              )
            }
          </div>
        ))}
          <div style={{display:'flex',justifyContent:'end',padding:'5px',gap:"20px"}}>
          <CancelButton variant='contained' color='primary' onClick={handleCancel}>Cancel</CancelButton>
         <ColorButton variant='contained' color='primary' onClick={handleCheckEmptyFilters}>Apply</ColorButton>
          </div> 
      </DialogContent>
    </Dialog>
  );
}
)

export default FilterPreview;